// import  Basic  from 'layouts/authentication/sign-in/basic';
import React, { lazy, Suspense } from 'react';
import { LinearProgress } from '@mui/material';

const Illustration = lazy(() => import('layouts/authentication/sign-in/illustration'));
const Basic = lazy(() => import('layouts/authentication/sign-in/basic'));
const Cover = lazy(() => import('layouts/authentication/forgot-password/cover'));

const ForgotPassword: React.FC = () => {
  return (
    <Suspense fallback={<LinearProgress sx={{ width: '-webkit-fill-available' }} />}>
      <Cover />
    </Suspense>
  );
};

export default ForgotPassword;
